/*
 * @Author: Cozy
 * @Date: 2024-05-08 18:45:31
 * @LastEditors: Cozy
 * @LastEditTime: 2024-07-29 18:56:42
 * @FilePath: /SChatUI/src/App.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import ChatList from "./ChatList";
import ChatPage from "./ChatPage";
import LoginPage from "./LoginPage";
import InsightChat from "./InsightChat";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><ChatList service="kualis" /></PrivateRoute>} />
          <Route path="/:service" element={<PrivateRoute><ChatList /></PrivateRoute>} />
          <Route path="/:service/c/:sessionId" element={<PrivateRoute><ChatPage /></PrivateRoute>} />
          <Route path="/unauthorized" element={<div>Unauthorized</div>} />
          <Route path="/insightchat" element={<InsightChat />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
